import { useState, useEffect } from 'react';
import { themeI18n } from '../utils/i18n_helper';
import { CompactProductCard } from './CompactProductCard';

export const CartUpsellContainer = ({ upsellJsonSettings }) => {
  const [recommendedProducts, setRecommendedProducts] = useState([]);

  const fetchRecommendations = async () => {
    const cartResponse = await fetch(window.location.origin + '/cart.json');
    const cartResponseJson = await cartResponse.json();
    const cartItems = await cartResponseJson.items;

    let recommendedProductArray = [];

    // Loop through the cart items and get recommendations for each product,
    // then add them to the recommendedProductArray if they are already there, increment the score
    await Promise.all(cartItems.map(async (cartItem) => {
      let recommndedAPI = await fetch(window.Shopify.routes.root
        + "recommendations/products.json?product_id="
        + cartItem.product_id
        + "&limit=5&intent=related");

      let recommndedAPIResponse = await recommndedAPI.json();
      let recommndedAPIResponseProducts = recommndedAPIResponse.products;

      recommndedAPIResponseProducts.forEach((newRecommendation) => {
        let oldRecommedation = recommendedProductArray.find((oldRecommedation) => oldRecommedation.id == newRecommendation.id);
        if (oldRecommedation) {
          oldRecommedation.score = oldRecommedation.score + 1;
        }
        else {
          newRecommendation.score = 1;
          recommendedProductArray.push(newRecommendation);
        }
      });
    }));

    let recommendedProductArraySorted = recommendedProductArray.sort((a, b) => b.score - a.score);

    setRecommendedProducts(recommendedProductArraySorted.slice(0, upsellJsonSettings.limit));
  }

  useEffect(() => {
    if (upsellJsonSettings.manual_products?.length > 0) {
      const products = upsellJsonSettings.manual_products.filter((product) => product.available).slice(0, upsellJsonSettings.limit);

      setRecommendedProducts(products);
    } else {
      fetchRecommendations();

      window.addEventListener('ajax-cart', fetchRecommendations);
    }

    return () => {
      if (!upsellJsonSettings.manual_products) {
        window.removeEventListener('ajax-cart', fetchRecommendations);
      }
    }
  }, []);

  if (recommendedProducts.length > 0) {
    return (
      <div className='cart-upsell'>
        <h3 className='cart-upsell__title h5'>
          {upsellJsonSettings.heading}
        </h3>

        <div className='cart-upsell__products'>
          {recommendedProducts.filter(product => product.price % 100 !== 97 && product.price % 100 !== 98).map(product => (
              <CompactProductCard
                product={product}
                key={product.id}
                complementaryProductsJson={upsellJsonSettings}
              />
            )
          )}
        </div>
      </div>
    );
  }
}
